import { render, staticRenderFns } from "./PatientsAll.vue?vue&type=template&id=60ae0df2&scoped=true&"
import script from "./PatientsAll.vue?vue&type=script&lang=js&"
export * from "./PatientsAll.vue?vue&type=script&lang=js&"
import style0 from "./PatientsAll.vue?vue&type=style&index=0&id=60ae0df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae0df2",
  null
  
)

export default component.exports